import Footer from "../components/footer/Footer"

export default function FooterSection() {
    return (
        <div className="bg-white">
           <Footer />
        </div>
    )
}